[
  {
    "url": "/_next/static/lompXyceXBmXjdDRQGEfk/_ssgManifest.js",
    "revision": null
  },
  {
    "url": "/_next/static/lompXyceXBmXjdDRQGEfk/_clientMiddlewareManifest.js",
    "revision": null
  },
  {
    "url": "/_next/static/lompXyceXBmXjdDRQGEfk/_buildManifest.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-420z18j1d8k0r.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-41fnhmokh-26v.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-40595y_vi94km.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-3y8w9eq990eoe.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-3x63ishxt07ex.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-3vmfuvpdd65fa.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-3sh5qsqj4zvqn.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-3mxq5smv660lc.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-3mh-v24z90s_d.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-3kz92jhu96xz_.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-3kl4yub7l04co.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-3dhckj__2rl5d.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-3bc3kp3_ft1fv.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-36m06mt04vqf-.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-320jn9-og1414.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-30xjxviv49740.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-3007dccqorbx6.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-3-x8pexq8qmkc.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-2ztr9y9gpnop7.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-2y3-nvocykzpf.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-2m7skj6ej-twu.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-2l0z33f6epn90.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-2k6vuf3ss_fmb.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-2ftjtb6f9_8et.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-2alcwmc1w8_g6.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-24gu776z9xj1r.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-2142svi3plb26.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-20eouuwl3r3fs.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-1st5k1wywvv2g.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-1rgxmqqcyakz4.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-1rcf1_-6si8la.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-1mmb0bbiu3ims.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-1hdwmjnfpzbxc.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-1amd11mjnz2pu.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-192xbz4b37ctp.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-11u4juen0mvvr.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-1-apbqizcu1ie.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-0vz4i2oatlbp5.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-0u9rchzhxifnf.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-0u011buwbcoim.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-0oe0ehhnfnpy3.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-0jbuzgzuxvzpm.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-0hvsuw27kxavc.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-0_ser5lke5th0.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-05c2kqnzxjo5e.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-02luk44vp1dcx.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-017-vrmp5-3qz.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-00tg3xsxh42tf.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-00l1s0kidlhhg.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-0-u7d6k7ne6-r.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/42i16_4ffyfay.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/418f0n0b3sbvh.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/410md7794o-t8.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/406sj2wzso3su.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3zdr_j4u4aetx.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3yxbkckuqxdep.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3xl7cowvkaybl.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3u82ph_a30m4m.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3t7j2hm3wwlkp.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3sknxc14k1de2.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3sgrg_52g__kb.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3q2r1uzqrgl5w.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3pk-l0m_-fzb3.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3nyh9stnii4xm.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3mntyb20i1_1g.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3ma3600-u59g-.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3l04zcqx63h3y.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3k_84kt1yk76m.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3k52_v_sl45l1.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3ialyp9tngov9.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3gpyc8rf41qhb.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3gl5legr0rsex.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3fwa46sg7hjfj.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3f1nywtazl7ah.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3drjo-pzntqlx.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3cjtj9kiuuy98.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3cig1ghnto5kx.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3aqdjmp7n0ryo.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3a_th82guq0um.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3_w69dxm0meqh.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3__r9atsioymd.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3_-9su1c43mb6.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/39is8z-_tvkl5.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/37grz_s8448sw.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/36_rs1seehubu.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/367jwotyz7bs6.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/35m86010n0shz.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/33os73dgikx59.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/30ontaa3k_6k9.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/300elbm8kh8b8.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3-6sx2d0er_rl.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2zy04v3-aculk.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2w1-dk0hg_bl5.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2sy8havouv0w0.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2qvkgjvw5_1r_.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2qpmrj5cmsuur.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2qliubxk28r4_.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2p2wug14-m36c.css",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2o0c__a1_x8ir.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2n5gkp7kvioep.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2ljoq6sr-g2da.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2lbn_nf415bvn.css",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2iq6k2jlnnj84.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2gnuptl6iiydl.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2glk5xh1jo6ix.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2fmxgkht559xb.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2f0gmy5kx6r8o.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2ccbz316u23r9.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2c5bots7749f6.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2atdoefnswz0t.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2a-67mr2u3ey9.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2_e8rmwaqabkq.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2_6y268lngfo4.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2_6cvhoeme0rf.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2_-jv2g8gnez1.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/29cd4o4jrd7f_.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/29-flwwag-rh6.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/28ktyexmslkpi.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/287yfrr9bvb5e.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/26iz93e_vrmx7.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/264bz3t6klsmo.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/24p0kf91ubjsg.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/24gcyrw27j1g9.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/24axsg_1cboul.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/23napt4xqxky5.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/22tktzm0gxi24.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/22_u17_pm2xp8.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/228kjdew8lj5v.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/21x4_-cie3z3k.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1zvo_o67j25vv.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1zii7lv4kjfca.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1wb9yf8il9giw.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1toywojbuc585.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1sz0v3crj68rg.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1ry--bxb4eugd.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1r3udbpvey5oo.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1qn136t-nc5cc.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1p3cdjbrfcdv9.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1oridk4xe-5ah.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1n-2rvkueodn5.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1knys9i88qtwq.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1ida4jyk0rsj8.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1h5c58b9u620_.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1h2-e_cxjbv-2.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1gv24wo7-a76_.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1fqu6_p29z8aj.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1fjlyq0gbxcqi.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1eqmccvzclf-e.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1e24jwg38luem.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1d6we3m3hiikz.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1cj96zkxu_g63.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1cb1hm_sf0222.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1ax0-afrm8t2h.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1ae-9ft5cgojf.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1_qu7ojb-xrjn.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1_o6wu4g12l8t.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1_nt3ct72quxi.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/17ryw7ywddka8.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/177p18lg_ch4m.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/15xtm9eotzf-1.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/15k5huuyfjvz1.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/12iw_rtez93tk.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/11np-8acnwfh_.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/11epj15ed_esd.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1-u1fzext5mwa.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1-jdfvdzeoos-.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0zg9649qfq7hx.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0yq95d0ml5mne.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0x4rd3vcvkfa8.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0vihyy8x5kaye.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0tsenh263bdpn.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0tppikyc7-j3h.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0tk_7_qomdn70.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0snqxudrlclbp.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0rbk570u6x-cq.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0pywnl4we9gv0.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0p7rpy3to6gde.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0jxb4aen2eqz-.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0itipktv0_1j2.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0i5kvbrl3oswq.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0h0r_q6xa9qr_.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0gyi6f2-odagj.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0fz1ald6ptybs.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0ed_is1_2va_a.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0e_s9uit7s_nj.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0d3nee8jp2gfa.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0cz1d0mv5g_q7.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0c6e6a-byleq1.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/09571lvi_g086.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/08ua9e7yus2df.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/08mi_r5tb-bm1.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/086qv37_e7l6w.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/08-hb3zbg2s-3.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/07dae1ka0kmd7.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/07_b_maqlh82g.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/06xea90b4mchg.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/06_xla5o8j_dh.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/05nrd0ctdk46i.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/05leg45xp8em8.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/056psiw-c9bo8.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/04vwoa1oyptfj.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/03kiji1z0nrcw.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/039eu5n543i0k.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/02gol4zlg9j_h.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0225g9zsgbetc.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/019kgfne_299c.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0-tzq4d69c1qb.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0-18ar1goovgu.js",
    "revision": null
  },
  {
    "url": "/robots.txt",
    "revision": "568aad510b71e567c428a2f01eb0d896"
  },
  {
    "url": "/_redirects",
    "revision": "8b0a5ac3b6eaccd9958d188fdaeed043"
  },
  {
    "url": "/scripts/loggly.js",
    "revision": "2e235dfc3dfb665af46815dec2b3e536"
  },
  {
    "url": "/scripts/linkedin_tracking.js",
    "revision": "8bdd10b3b5457f1ce0812c9373a8e918"
  },
  {
    "url": "/scripts/google.js",
    "revision": "c50b815df7bf1ba570fc8da7a5262194"
  },
  {
    "url": "/scripts/templates/articles/wishlist-2023/images/image0.png",
    "revision": "08661f4e714751845d71d15457c29e9b"
  },
  {
    "url": "/scripts/templates/articles/tech-skills/image1.png",
    "revision": "59b69c945b664bdbeb149a9e40c9b655"
  },
  {
    "url": "/scripts/templates/articles/software-factory-101/images/image2.png",
    "revision": "0189b64f4e2c9620d9c3fb07132f48ca"
  },
  {
    "url": "/scripts/templates/articles/software-factory-101/images/image1.png",
    "revision": "ad9c2ed03916b3981a7850b26d40660a"
  },
  {
    "url": "/scripts/templates/articles/master-emotions/images/image2.gif",
    "revision": "529ba7adea89de09ac230f945de110ff"
  },
  {
    "url": "/scripts/templates/articles/master-emotions/images/image1.png",
    "revision": "6af1a311316d026109de83013a151373"
  },
  {
    "url": "/scripts/templates/articles/luxembourg-startup-ecosystem/images/image1.png",
    "revision": "3451bec0674d22e3b3d0a252a6af6248"
  },
  {
    "url": "/scripts/templates/articles/luxembourg-startup-ecosystem/images/image0.png",
    "revision": "3e179ab37bc685627a30c43850652827"
  },
  {
    "url": "/scripts/templates/articles/it-infrastructure-plan-you-wont-outgrow/images/image0.png",
    "revision": "5e1c5d54277546495814ff526e7ab24c"
  },
  {
    "url": "/scripts/templates/articles/how-to-maximize-productivity-with-gmail/images/image3.png",
    "revision": "63fc398685f31f5707333e6965178ec1"
  },
  {
    "url": "/scripts/templates/articles/how-to-maximize-productivity-with-gmail/images/image2.png",
    "revision": "08a4e6c71865634651a6e6021c3f6ce0"
  },
  {
    "url": "/scripts/templates/articles/how-to-maximize-productivity-with-gmail/images/image1.png",
    "revision": "13246ec8e4ba2fb6c26023205ac50c6c"
  },
  {
    "url": "/scripts/templates/articles/how-to-maximize-productivity-with-gmail/images/image1.jpg",
    "revision": "49a7149dd363fd14621278aa86fc5e8f"
  },
  {
    "url": "/scripts/templates/articles/how-duplicate-yourself/images/image0.png",
    "revision": "e5bd4a7f998dca9a2367ad96b9af3ccd"
  },
  {
    "url": "/scripts/templates/articles/hiring-engineer-non-technical/images/image0.png",
    "revision": "dff123eba59eda2f2da22734283cc98f"
  },
  {
    "url": "/scripts/templates/articles/happy-developer/images/image0.png",
    "revision": "bb46d217d29e36eef9cf470e1a2d294e"
  },
  {
    "url": "/scripts/templates/articles/hacks-healthy-company-culture/images/image1.png",
    "revision": "86acc27d248e0d4c5c411d138d667aaa"
  },
  {
    "url": "/scripts/templates/articles/from-idea-to-product-market-fit/images/image9.png",
    "revision": "a9155579cd6c156c1b1eb4f1f15d2bef"
  },
  {
    "url": "/scripts/templates/articles/from-idea-to-product-market-fit/images/image8.png",
    "revision": "7f9ceb8e210183eb5e82583e59c98148"
  },
  {
    "url": "/scripts/templates/articles/from-idea-to-product-market-fit/images/image7.png",
    "revision": "119d1c6429cfd32587a69207ca4474de"
  },
  {
    "url": "/scripts/templates/articles/from-idea-to-product-market-fit/images/image6.png",
    "revision": "547c355798faffa182590b6d98c78571"
  },
  {
    "url": "/scripts/templates/articles/from-idea-to-product-market-fit/images/image5.png",
    "revision": "02a5d87f6d1e39eaec85995ba774585e"
  },
  {
    "url": "/scripts/templates/articles/from-idea-to-product-market-fit/images/image4.png",
    "revision": "47fe394a2de544aa24d5805552952567"
  },
  {
    "url": "/scripts/templates/articles/from-idea-to-product-market-fit/images/image3.png",
    "revision": "979555843258aae85e5b8651617268a0"
  },
  {
    "url": "/scripts/templates/articles/from-idea-to-product-market-fit/images/image2.png",
    "revision": "cb8d05b2ae1c8d813971ba998447be15"
  },
  {
    "url": "/scripts/templates/articles/from-idea-to-product-market-fit/images/image13.png",
    "revision": "f4f95877444108b091a1da2c9db9f750"
  },
  {
    "url": "/scripts/templates/articles/from-idea-to-product-market-fit/images/image12.png",
    "revision": "8ba557ee4de46ab8714f8437f2c8caba"
  },
  {
    "url": "/scripts/templates/articles/from-idea-to-product-market-fit/images/image11.png",
    "revision": "e54742854c388014a30f0e91469fbf51"
  },
  {
    "url": "/scripts/templates/articles/from-idea-to-product-market-fit/images/image10.png",
    "revision": "eee4aba6d551d9f67f01f3f31be33e2c"
  },
  {
    "url": "/scripts/templates/articles/from-idea-to-product-market-fit/images/image1.png",
    "revision": "2709637818c6164d4d442d22e1eb0e52"
  },
  {
    "url": "/scripts/templates/articles/flow-state-enhancing-employee-engagement/images/image3.png",
    "revision": "11bb83eac9753621d0a636bf330c60ca"
  },
  {
    "url": "/scripts/templates/articles/flow-state-enhancing-employee-engagement/images/image2.png",
    "revision": "815f66024391f80d6e94acfc377d38e7"
  },
  {
    "url": "/scripts/templates/articles/flow-state-enhancing-employee-engagement/images/image1.png",
    "revision": "7f9362f7b34ccc326a14c0338c4b985a"
  },
  {
    "url": "/scripts/templates/articles/emergent-behavior-to-supercharge-your-workplace/images/wolf-and-sheep.png",
    "revision": "3c83999658f88f8d6d3de939a5199d8f"
  },
  {
    "url": "/scripts/templates/articles/emergent-behavior-to-supercharge-your-workplace/images/termite-2.png",
    "revision": "2afd91f643987c9174c5c6749866c539"
  },
  {
    "url": "/scripts/templates/articles/emergent-behavior-to-supercharge-your-workplace/images/termite-1.png",
    "revision": "39b7deb7846b293ce0b6f5c0730a117a"
  },
  {
    "url": "/scripts/templates/articles/emergent-behavior-to-supercharge-your-workplace/images/covid19-infection-simulation.png",
    "revision": "f6bcc123cf725b75ceccb4fb2d52b9d0"
  },
  {
    "url": "/scripts/templates/articles/emergent-behavior-to-supercharge-your-workplace/images/agent-of-city.png",
    "revision": "797280ae23ea78c3bf095b1712ada6dc"
  },
  {
    "url": "/scripts/templates/articles/digitizing-business-archives/images/image0.png",
    "revision": "bb2d3d1b21a95de9c5073272ac7fe45a"
  },
  {
    "url": "/scripts/templates/articles/data-visualizations/images/image1.png",
    "revision": "09bc23b57c3918c18514566890b072b8"
  },
  {
    "url": "/scripts/templates/articles/create-winning-pitch-deck-raise-funds/images/image9.png",
    "revision": "0b58c11eafe3499a23f700d7ffd97131"
  },
  {
    "url": "/scripts/templates/articles/create-winning-pitch-deck-raise-funds/images/image8.png",
    "revision": "f3bc5b74682a1cb501b40f61d678991d"
  },
  {
    "url": "/scripts/templates/articles/create-winning-pitch-deck-raise-funds/images/image7.png",
    "revision": "0b42e4928c75fa176b60bc8b1d89c12c"
  },
  {
    "url": "/scripts/templates/articles/create-winning-pitch-deck-raise-funds/images/image6.png",
    "revision": "92e82c756c715f3b516403bd80bfdf23"
  },
  {
    "url": "/scripts/templates/articles/create-winning-pitch-deck-raise-funds/images/image5.png",
    "revision": "e93308ae747688258a996e88af9e295a"
  },
  {
    "url": "/scripts/templates/articles/create-winning-pitch-deck-raise-funds/images/image4.png",
    "revision": "854be8cc7c27067363ca2caed79fdcd0"
  },
  {
    "url": "/scripts/templates/articles/create-winning-pitch-deck-raise-funds/images/image3.png",
    "revision": "a74af9c592983969b67bfaeff20e125d"
  },
  {
    "url": "/scripts/templates/articles/create-winning-pitch-deck-raise-funds/images/image2.png",
    "revision": "eace60668afaab39b079ad7f1ae708cf"
  },
  {
    "url": "/scripts/templates/articles/create-winning-pitch-deck-raise-funds/images/image10.png",
    "revision": "df178e11597ac9da52be383644351cb3"
  },
  {
    "url": "/scripts/templates/articles/create-winning-pitch-deck-raise-funds/images/image1.png",
    "revision": "542f53719000d96d8f7a295427519775"
  },
  {
    "url": "/scripts/templates/articles/buzzwords-dictionary/images/image1.png",
    "revision": "f3d814e461ddf5d2887fe8960e495352"
  },
  {
    "url": "/scripts/templates/articles/boost-hiring-with-marketing-strategies/images/image1.png",
    "revision": "7c3cf497a2a40b3e5d69abbc2a810578"
  },
  {
    "url": "/scripts/templates/articles/back-to-school/images/image1.png",
    "revision": "451185da73a4f5b2de96d048a1fe6858"
  },
  {
    "url": "/scripts/templates/articles/back-to-school/images/image0.png",
    "revision": "bdfc6a8e6cd31f10268af877954eed98"
  },
  {
    "url": "/scripts/templates/articles/as-a-cto-how-should-i-spend-my-time/images/image2.png",
    "revision": "0ac4844fcf89e3353af0fae3af2f369c"
  },
  {
    "url": "/scripts/templates/articles/alliance/images/image1.png",
    "revision": "1b1f4fd6cf2431091bac64bf74ecb699"
  },
  {
    "url": "/images/logos/ziverge-logo.svg",
    "revision": "46da5bbaaf8c33cf9760a8cae9591492"
  },
  {
    "url": "/images/logos/vestis_labs.webp",
    "revision": "dbaa0f65a55c36373c6a3fdf0354a86d"
  },
  {
    "url": "/images/logos/vencapital-logo.webp",
    "revision": "3397aaea3c0f198575eba51c521c98a2"
  },
  {
    "url": "/images/logos/university_luxembourg.png",
    "revision": "08ad3ad56c52f72255e0e5fb79d0aa25"
  },
  {
    "url": "/images/logos/todaers-logo.jpeg",
    "revision": "a93490218bb0f2299a7894e96d375f39"
  },
  {
    "url": "/images/logos/the-european-vc-logo.png",
    "revision": "c45d319f8d878f7f2f80f9917a16d2c6"
  },
  {
    "url": "/images/logos/swg.png",
    "revision": "f6950db5ebea51fe579ca359c35bb572"
  },
  {
    "url": "/images/logos/space-foundation-logo.png",
    "revision": "198e995b256875566d32370e89f868fa"
  },
  {
    "url": "/images/logos/recube-logo.jpeg",
    "revision": "6ad273b8c824f255379c16f1e5f7307d"
  },
  {
    "url": "/images/logos/loyal_vc.png",
    "revision": "bdc920a3fa989b5e38a16af3a83623d1"
  },
  {
    "url": "/images/logos/gdg_ratoma.svg",
    "revision": "cb5180fda8601f82e2c078916b4f0e4a"
  },
  {
    "url": "/images/logos/gbeta_cheyenne.png",
    "revision": "18654a17bdcb5fd3defd6ae4a60b1c92"
  },
  {
    "url": "/images/logos/founder_institute.png",
    "revision": "33318b0561e0b1c76dec8ffa38329d24"
  },
  {
    "url": "/images/logos/fit4start-logo.svg",
    "revision": "13a499ffef600585dada9299cdcd9e4d"
  },
  {
    "url": "/images/logos/fit4start-logo.png",
    "revision": "de6ed25cb1d687efb69f67b215f1be27"
  },
  {
    "url": "/images/logos/discord-mark-white.png",
    "revision": "a9ab4928517e02c39380e9d47f567bef"
  },
  {
    "url": "/images/logos/NewChip-logo.png",
    "revision": "03eb9f9cf07ec9f1ee63cfb2a8c88945"
  },
  {
    "url": "/images/logos/500Startups-logo.png",
    "revision": "60770d95a434bbaa20da1ce9541377f6"
  },
  {
    "url": "/images/img/thanks.png",
    "revision": "03172a24ab63197234013d11c2ae8731"
  },
  {
    "url": "/images/img/tech_with_bckgrd_zoomed_comp.png",
    "revision": "238e09be073b813d72ae8e8687147d88"
  },
  {
    "url": "/images/img/tech_with_bckgrd_zoomed.png",
    "revision": "01cba2047372e99d94518dde78550890"
  },
  {
    "url": "/images/img/tech_with_bckgrd.png",
    "revision": "171b46374fd475093b7991097b4c6f1a"
  },
  {
    "url": "/images/img/tech.png",
    "revision": "dc47f103cc7f59dd001ab687c20819ca"
  },
  {
    "url": "/images/img/team.png",
    "revision": "51ec0b46d50d6bb60960bf71423580fe"
  },
  {
    "url": "/images/img/rd.png",
    "revision": "b031f97ad9395a2cfd19b5cd93911107"
  },
  {
    "url": "/images/img/panorama.png",
    "revision": "522d5a4de33c282b9d8bc67d50e8e07e"
  },
  {
    "url": "/images/img/leo.png",
    "revision": "7d036e56f3729d8c0ea38ecca10c0238"
  },
  {
    "url": "/images/img/founders_map.png",
    "revision": "62aaa686cef0e2c50030dff4ea52bd14"
  },
  {
    "url": "/images/img/contact.png",
    "revision": "0eef635cc7c09c178077cf7b96907a9c"
  },
  {
    "url": "/images/icons/youtube-logo.png",
    "revision": "1ed15b31faa0de363a7b465ee9e7a256"
  },
  {
    "url": "/images/icons/tech.svg",
    "revision": "6cd208056ff7b44084d1638504507fdc"
  },
  {
    "url": "/images/icons/team.svg",
    "revision": "a57676fe7e63147c3dfcd4b31f0656db"
  },
  {
    "url": "/images/icons/startup-grind-logo.svg",
    "revision": "c2a14554e79b4f9db2c861a73d595382"
  },
  {
    "url": "/images/icons/silicon-luxembourg-logo.png",
    "revision": "a9a8d0a9ef57a892bae20d9985e8732a"
  },
  {
    "url": "/images/icons/rd.svg",
    "revision": "1bf3ae1d84d7a778daa65dd811bfabb9"
  },
  {
    "url": "/images/icons/questions.svg",
    "revision": "b1f03882ae8ef3e200547d339a46c4ea"
  },
  {
    "url": "/images/icons/pure-lambda-logo.png",
    "revision": "9af207706cb83134909c252e5d23da60"
  },
  {
    "url": "/images/icons/pure-lambda-logo-10.svg",
    "revision": "588db8403c64e90d058712dd77c07e76"
  },
  {
    "url": "/images/icons/pure-lambda-logo-10-top.svg",
    "revision": "f97cb9b41acaaad22cc6af4dd54404ca"
  },
  {
    "url": "/images/icons/pure-lambda-logo-10-square.png",
    "revision": "d7f8b43bef38e7e6a2cc0f26a0aec816"
  },
  {
    "url": "/images/icons/pure-lambda-logo-10-square copy 4.png",
    "revision": "e95ea7bc8b364cdca6795954e8539cfc"
  },
  {
    "url": "/images/icons/pure-lambda-logo-10-circle.png",
    "revision": "402570197a01f99da7830963f788fe48"
  },
  {
    "url": "/images/icons/pure-lambda-logo-10-bottom.svg",
    "revision": "7b0fbeeedef6a856361b738493ce3e45"
  },
  {
    "url": "/images/icons/paperjam-logo.svg",
    "revision": "08c95fca4d8df1d67f247ca0123444e8"
  },
  {
    "url": "/images/icons/medium-logo-full.svg",
    "revision": "6d69d798ac9c32b729305e98c38fd055"
  },
  {
    "url": "/images/icons/luxembourg.png",
    "revision": "7a097cf7e97ccaf018fe9386e0233236"
  },
  {
    "url": "/images/icons/luxembourg-original.png",
    "revision": "3af734547d19798712f417038ff1ff2f"
  },
  {
    "url": "/images/icons/kintell-logo.png",
    "revision": "a7356efcf435d280e5b16688267e8288"
  },
  {
    "url": "/images/icons/it-one-logo.jpeg",
    "revision": "27867fe9927774e885f36824803586e0"
  },
  {
    "url": "/images/icons/five-offices-logo.svg",
    "revision": "74bcf303b4cbbd3198867f2438b687ae"
  },
  {
    "url": "/images/icons/electro-monkeys-logo.png",
    "revision": "b32579dc13f5137db868f05ddeaff3b8"
  },
  {
    "url": "/images/icons/authority-magazine.gif",
    "revision": "93eea096f5f8e2df8df30df5f50ab0a5"
  },
  {
    "url": "/images/icons/Twitter.png",
    "revision": "9fd9b71b3e7b1d485cf9082065fa3ae5"
  },
  {
    "url": "/images/icons/LinkedIn.png",
    "revision": "5a38f775dce2351db23510bea0f31b21"
  },
  {
    "url": "/images/icons/AngelList.png",
    "revision": "2e7785ae7b6e009a161236a11cfebcaf"
  },
  {
    "url": "/images/icons/AngelList-original.png",
    "revision": "85c592a7ddd42b129e6f9b42cf9329ac"
  },
  {
    "url": "/fonts/AlteHaasGroteskBold.ttf",
    "revision": "8dddfc4c12cf25d9913689b1969523d7"
  },
  {
    "url": "/favicon/mstile-70x70.png",
    "revision": "eb83ad5c65442b37711ef605a80c2c4f"
  },
  {
    "url": "/favicon/mstile-310x310.png",
    "revision": "756c13c351ab950bda586372a77493ed"
  },
  {
    "url": "/favicon/mstile-310x150.png",
    "revision": "da432a62b5166e10e8809c496ca51b58"
  },
  {
    "url": "/favicon/mstile-150x150.png",
    "revision": "f4163ebb97d7af64770a858253d364e1"
  },
  {
    "url": "/favicon/mstile-144x144.png",
    "revision": "b72f6f391b4247d3c4c12fc632b25a00"
  },
  {
    "url": "/favicon/manifest.json",
    "revision": "bbc3e36285172524b5478a3475ad193a"
  },
  {
    "url": "/favicon/logo-3000x3000.png",
    "revision": "323b646043c35d77b9cad86832cb70ad"
  },
  {
    "url": "/favicon/favicon.ico",
    "revision": "1cee53b275930df95e4e142e3df456b3"
  },
  {
    "url": "/favicon/favicon-96x96.png",
    "revision": "ae6d06985c3057624dbfc7fec1d65bde"
  },
  {
    "url": "/favicon/favicon-32x32.png",
    "revision": "2f9dc1f61e53c0eff9d09d1e86e14cc3"
  },
  {
    "url": "/favicon/favicon-196x196.png",
    "revision": "b1bb844ec0dce8dbf1069eeb79a1dd69"
  },
  {
    "url": "/favicon/favicon-16x16.png",
    "revision": "0650900cb06ec218d01f7a864db5c30a"
  },
  {
    "url": "/favicon/favicon-128x128.png",
    "revision": "eb83ad5c65442b37711ef605a80c2c4f"
  },
  {
    "url": "/favicon/code.txt",
    "revision": "f45e27c9a57ee7751eebddb207877c64"
  },
  {
    "url": "/favicon/browserconfig.xml",
    "revision": "c39608b3059bc24dd28e3fe21cf68041"
  },
  {
    "url": "/favicon/apple-touch-icon-76x76.png",
    "revision": "a1118c04b393f9018ffaa84b304a94da"
  },
  {
    "url": "/favicon/apple-touch-icon-72x72.png",
    "revision": "803227ce84bfff22620e7b006a802217"
  },
  {
    "url": "/favicon/apple-touch-icon-60x60.png",
    "revision": "2b0b05dadf89ca7e1a0a7415bd76f415"
  },
  {
    "url": "/favicon/apple-touch-icon-57x57.png",
    "revision": "86988493dec0c9c47c261f0b8c8819f0"
  },
  {
    "url": "/favicon/apple-touch-icon-152x152.png",
    "revision": "809162da586fe0403ddd4ec80fa79f55"
  },
  {
    "url": "/favicon/apple-touch-icon-144x144.png",
    "revision": "b72f6f391b4247d3c4c12fc632b25a00"
  },
  {
    "url": "/favicon/apple-touch-icon-120x120.png",
    "revision": "a39195a0d20e28d9f7befe5b21cd9de1"
  },
  {
    "url": "/favicon/apple-touch-icon-114x114.png",
    "revision": "024d67e71c1c3c9e2537910d7e1b1138"
  },
  {
    "url": "/assets/pure-lambda-logo-10.svg",
    "revision": "588db8403c64e90d058712dd77c07e76"
  },
  {
    "url": "/assets/pure-lambda-logo-10-top.svg",
    "revision": "f97cb9b41acaaad22cc6af4dd54404ca"
  },
  {
    "url": "/assets/pure-lambda-logo-10-square.png",
    "revision": "d7f8b43bef38e7e6a2cc0f26a0aec816"
  },
  {
    "url": "/assets/pure-lambda-logo-10-circle.png",
    "revision": "402570197a01f99da7830963f788fe48"
  },
  {
    "url": "/assets/pure-lambda-logo-10-bottom.svg",
    "revision": "7b0fbeeedef6a856361b738493ce3e45"
  },
  {
    "url": "/assets/degrees/certificat DEVFEST Conakry 2020 Leo Benkel.webp",
    "revision": "2ffb4693280163ac796dd83532d432a3"
  },
  {
    "url": "/assets/degrees/certificat DEVFEST Conakry 2020 Leo Benkel.jpg",
    "revision": "3d4221c8896acf781512b68c0da64402"
  }
]